import { createContext } from 'react';

export const AuthContext = createContext();
export const AppSettingsContext = createContext();
export const GlobalValuesContext = createContext();
